const LAST_STEP_TEXT = 'Letzter Schritt!'
const TWO_STEPS_LEFT_TEXT = 'Nur noch 2 Schritte'
const THREE_STEPS_LEFT_TEXT = 'Nur noch 3 Schritte'

export const getMotivationalTextMessage = (
  currentPageInSession: string | null,
  isCarLoanPurpose: boolean
): string => {
  if (currentPageInSession === 'payoutAccount') {
    return LAST_STEP_TEXT
  }

  if (isCarLoanPurpose) {
    if (currentPageInSession === 'vehicle') {
      return TWO_STEPS_LEFT_TEXT
    }

    if (currentPageInSession === 'activeLoans') {
      return THREE_STEPS_LEFT_TEXT
    }
  }

  if (!isCarLoanPurpose) {
    if (currentPageInSession === 'activeLoans') {
      return TWO_STEPS_LEFT_TEXT
    }

    if (currentPageInSession === 'employment') {
      return THREE_STEPS_LEFT_TEXT
    }
  }

  return ''
}
